import React from 'react';
import {useField} from 'react-final-form';
import Input from 'common/componentsV2/Input';

const validate = (value) => {
  return !value && 'Service key is mandatory';
};

const ServiceKey = () => {
  const {
    input: {value, onChange, onBlur},
    meta,
  } = useField('serviceKey', {validate});
  return (
    <div>
      <div>Service Key</div>
      <Input
        placeHolder="4f67a0d778984c4f9aff8bd4f7d73ab0"
        automationId="serviceKey"
        isInvalid={meta.touched && meta.error}
        invalidMessage={meta.error}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    </div>
  );
};

export default ServiceKey;
